module.exports = __webpack_public_path__ + "media/images/pc/brands/sola/store_hokkaido-033cee2d88039ac95bc6d54ba8bdd813.jpg";